import { ExplanationJsonModel } from '../../explanation.json.model';

export namespace ExplanationActions {
  export class Add {
    static readonly type = getActionName('Add');
    constructor(readonly payload: ExplanationJsonModel) {}
  }

  export class Edit {
    static readonly type = getActionName('Edit');
    constructor(readonly payload: ExplanationJsonModel) {}
  }

  export class Delete {
    static readonly type = getActionName('Delete');
    constructor(readonly payload: ExplanationJsonModel) {}
  }

  export class Fetch {
    static readonly type = getActionName('Fetch');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccess {
    static readonly type = getActionName('Fetch success');
    constructor(readonly payload: ExplanationJsonModel[]) {}
  }

  export class FetchOne {
    static readonly type = getActionName('Fetch One');
    constructor(public id: string) {}
  }

  export class FetchOneSuccess {
    static readonly type = getActionName('Fetch One Success');
    constructor(public payload: ExplanationJsonModel) {}
  }

  export class FetchAppend {
    static readonly type = getActionName('Fetch and append');
    constructor(
      public overrideOptions?: {
        pageNumber?: number
        pageSize?: number
        skipStoreDispatch?: boolean
      }
    ) {}
  }

  export class FetchSuccessAppend {
    static readonly type = getActionName('Fetch success append');
    constructor(readonly payload: ExplanationJsonModel[]) {}
  }

  function getActionName(type: string) {
    return `[Explanation] ${type}`;
  }
}
